import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function CommercialTransactionsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" size="sm" className="mb-6 gap-1.5">
            <ArrowLeft className="h-4 w-4" />
            トップへ戻る
          </Button>
        </Link>

        <h1 className="text-lg font-bold mb-1">特定商取引法に基づく表記</h1>
        <p className="text-xs text-muted-foreground mb-6">最終更新日: 2026年2月21日</p>

        <div className="max-w-none text-xs">
          <table className="w-full border-collapse">
            <tbody className="divide-y divide-border">
              <Row label="販売業者" value="個人事業主（屋号: Hitorigoto）" />
              <Row label="運営責任者" value="星 治輝" />
              <Row label="所在地" value="請求があった場合には遅滞なく開示いたします。下記メールアドレスまでご連絡ください。" />
              <Row label="電話番号" value="請求があった場合には遅滞なく開示いたします。下記メールアドレスまでご連絡ください。" />
              <Row label="メールアドレス" value="support@hitorigoto.app" />
              <Row label="販売URL" value="https://hitorigoto.app" />
              <Row
                label="販売価格"
                value={
                  <>
                    <p>プレミアムプラン（月額）: 550円（税込）</p>
                    <p>プレミアムプラン（年額）: 5,400円（税込）</p>
                    <p className="mt-1 text-muted-foreground">※ 価格は予告なく変更される場合があります。変更前に契約中のプランには影響しません。</p>
                  </>
                }
              />
              <Row label="販売価格以外の必要料金" value="インターネット接続に必要な通信費用はお客様のご負担となります。" />
              <Row label="支払方法" value="クレジットカード決済（Stripe経由）" />
              <Row label="支払時期" value="月額プラン: 毎月の契約日に自動課金。年額プラン: 契約日に一括課金。" />
              <Row label="商品の引渡時期" value="決済完了後、即時にプレミアム機能をご利用いただけます。" />
              <Row
                label="返品・キャンセルについて"
                value={
                  <>
                    <p>デジタルコンテンツの性質上、購入後の返品・返金は原則としてお受けしておりません。</p>
                    <p className="mt-1">サブスクリプションはいつでもキャンセル可能です。キャンセル後も現在の請求期間の終了まで引き続きプレミアム機能をご利用いただけます。</p>
                  </>
                }
              />
              <Row label="動作環境" value="最新版の Google Chrome、Safari、Firefox、Microsoft Edge。インターネット接続が必要です。" />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Row({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <tr>
      <td className="py-3 pr-4 font-medium align-top whitespace-nowrap w-[140px]">{label}</td>
      <td className="py-3 text-muted-foreground leading-relaxed">{value}</td>
    </tr>
  );
}
